export const en = {
  logo: 'Inbal Art Makers',
  nav: {
    categories: 'Categories',
    myOrders: 'My Orders',
    deals: 'Amazon Deals',
    tutorials: 'Tutorials',
    workshops: 'Workshops',
    shop: 'Shop',
    about: 'About',
    contact: 'Contact',
    admin: 'Admin',
    cricut: 'Cricut',
    goldsmith: 'Goldsmith',
    teva: 'Teva',
    modeling3d: 'Modeling3D',
    svgfiles: 'SVG Files',
    sublimation: 'Sublimation',
    others: 'Others'
  },
  search: 'Search',
  searchPlaceholder: 'Search tutorials, products, workshops...',
  cart: 'Cart',
  language: 'Language',
  account: 'Account',
  login: 'Login',
  logout: 'Logout'
}; 